// store/thunks/auth/sendPhoneCodeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { VerificationDTO } from '@/types/DTOs';

export const sendPhoneCodeThunk = createAppAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/sendPhoneCode',
  async(_, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendPhoneCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send email code';
      return rejectWithValue({ message });
    }
  }
);
